export { DesignerAttribution } from './components/designer-attribution/designer-attribution.component.js';
